import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" {...props}><path fillRule="evenodd" d="M34 18c0 8.837-7.163 16-16 16S2 26.837 2 18 9.163 2 18 2a16 16 0 0116 16zm-6 0a.75.75 0 01-.75.75H8.75a.75.75 0 010-1.5h18.5A.75.75 0 0128 18z" /></svg>);